import { createRoot } from 'react-dom/client'
import { COMPONENT_NAME } from './oracle-guide-on-side-component'
import { BUTTON_COMPONENT_NAME } from './oracle-guide-on-side-button'

export const PLUGIN_NAME = 'OracleGuideOnSide'

/**
 * Oracle Guide on Side plugin function.
 *
 * Uses the "basic plugin" pattern where `this` is the player instance.
 * This avoids ES6 class inheritance issues with video.js Plugin class
 * when transpiling TypeScript through Babel.
 *
 * Following the video-player-app pattern: React mounting is done here
 * in the plugin function, not in the component class.
 *
 * @param {Object} options - Plugin options
 * @param {Function} options.render - Function that returns React component to mount
 * @param {Function} options.onOpenGuide - Callback when button is clicked
 */
export function oracleGuideOnSidePlugin (options = {}) {
  const { render, onOpenGuide } = options
  const player = this

  player.ready(() => {
    let root

    // Add CSS class to player element for styling hooks
    player.addClass('vjs-oracle-guide-on-side-enabled')

    // Add button to control bar (visual position controlled by CSS order)
    player.controlBar.addChild(BUTTON_COMPONENT_NAME, { onOpenGuide })

    // Create and add the component directly to player (not control bar)
    const videoJsComponent = player.addChild(COMPONENT_NAME)

    // Wait until the component DOM element is ready, then mount React
    let attempt = 0
    const intervalId = player.setInterval(() => {
      const domElement = videoJsComponent.el()
      attempt += 1

      if (!domElement) {
        if (attempt > 10) {
          player.clearInterval(intervalId)
        }
        return
      }

      // Render React component
      const component = render(player, options)
      root = createRoot(domElement)
      root.render(component)
      player.clearInterval(intervalId)
    }, 100)

    // Handle cleanup when component is disposed
    videoJsComponent.one('dispose', () => {
      player.setTimeout(() => {
        if (root && root.unmount) {
          root.unmount()
          root = undefined
        }
      }, 0)
    })
  })
}
